module.exports = __webpack_public_path__ + "img/能誉浅色-02.f14968cd.png";